<template>
  <div>
    <span v-if="itemType === 'curriculum'">
      <v-chip color="primary">{{ itemType }}</v-chip>
      <h4 class="d-inline-block">{{ item.name }}</h4>
    </span>
    <span v-if="itemType === 'intention'">
      <v-chip color="secondary">{{ itemType }}</v-chip>
      <h5 class="d-inline-block">{{ item.title }}</h5>
    </span>
    <span v-if="itemType === 'pos'">
      <small class="font-weight-bold d-inline-block">[{{ item.code }}]</small>
      <small class="d-inline-block">{{ item.description }}</small>
    </span>
  </div>
</template>

<script>
export default {
  name: 'custom-tree-view-item',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  computed: {
    itemType() {
      let type = '???';
      if (this.item) {
        if (this.item.intentions) {
          type = 'curriculum';
        } else if (this.item.pos) {
          type = 'intention';
        } else {
          type = 'pos';
        }
      }
      return type;
    },
  },
};
</script>

<style scoped>
</style>
